// extracted by mini-css-extract-plugin
var _1 = "webpack-components-core-Card-Card-module__Card";
export { _1 as "Card" }
